import React, { useState } from "react";
import CalendarModal from "./calendar-modal";
import { useTranslation } from "react-i18next";
import { getStringDay, getStringMonth } from "../../../utils/functions";
import { useSelector } from "react-redux";
import { getSessionInfo } from "../../../../Redux/reducer/session";
import { getBillStatusKey } from "../../../utils/utilities";
import Dday from '../../../../../static/images/Dday.svg';
import Repago from '../../../../../static/images/repago.svg';


const CalendarItem = (props) => {
  const { itemCalendar } = props;
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  var date = new Date(itemCalendar.date);
  const stringDate = `${getStringDay(
    date.getUTCDay()
  )} ${date.getUTCDate()} de ${getStringMonth(
    date.getUTCMonth()
  )} del ${date.getUTCFullYear()}`;

  const message =
    itemCalendar.status == "DDAY"
      ? t("dashboard.expiration.ddayLegend")
      : t("dashboard.expiration.repayLegend");

  const loggedUser = useSelector((state) => getSessionInfo(state));
  const billStatusCode = getBillStatusKey(
    itemCalendar.status,
    loggedUser.userType
  );

  return (
    <div className="items">
      <div className="item-date">
        {stringDate.charAt(0).toUpperCase() + stringDate.slice(1)}
      </div>
      <div className={`item-box`} onClick={() => setModalOpen(true)}>
        <div className="item-img">
          {itemCalendar.status.toLowerCase() === "dday" && (
            <img alt="calendar" src={Dday} />
          )}

          {itemCalendar.status.toLowerCase() === "repago" && (
            <img alt="calendar" src={Repago} />
          )}
        </div>
        <p>
          {message} <a href="#">{t("dashboard.expiration.more")}</a>
        </p>
        <p className="item-btn">
          {t(`general.billStates.${billStatusCode}`)}
        </p>
      </div>
      {modalOpen && (
        <CalendarModal
          mode={itemCalendar.status}
          statusCode={billStatusCode}
          date={itemCalendar.date}
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default CalendarItem;
